import { render, staticRenderFns } from "./CrudJudges.vue?vue&type=template&id=1dc0af0f&"
import script from "./CrudJudges.vue?vue&type=script&lang=js&"
export * from "./CrudJudges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports